/* Cayo Hueso - temporary creator pop-up (markup: snippets/cayo-creator-popup.liquid).
   Opens ~0.4 s after the homepage splash overlay has faded out and been removed (cayo-intro.js fires 'cayo:intro-closed'),
   or ~0.4 s after load when the splash is switched off. Close: X, No Thanks, backdrop, Escape -> fade, remove, restore. */
(function () {
  'use strict';
  var el = document.getElementById('cayo-popup');
  if (!el || !el.parentNode) return;
  var doc = document.documentElement;
  var card = el.querySelector('.cayo-popup__card');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DELAY = 400, OUT_MS = reduce ? 0 : 350;
  var state = 'idle', inerted = [], prevFocus = null;

  function focusables() {
    return Array.prototype.filter.call(card.querySelectorAll('a[href], button'), function (b) { return !b.disabled && b.offsetParent !== null; });
  }
  function onKey(e) {
    if (state !== 'open') return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || a === card || !card.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !card.contains(a))) { e.preventDefault(); first.focus(); }
    }
  }
  function open() {
    if (state !== 'idle' || !el.parentNode) return;
    state = 'open';
    prevFocus = document.activeElement;
    Array.prototype.forEach.call(document.body.children, function (c) {
      if (c === el || c.tagName === 'SCRIPT' || c.hasAttribute('inert')) return;
      c.setAttribute('inert', ''); inerted.push(c);
    });
    doc.classList.add('cayo-popup-open');
    el.hidden = false;
    void el.offsetWidth; // start the fade from opacity 0
    el.classList.add('is-open');
    document.addEventListener('keydown', onKey, true);
    card.focus({ preventScroll: true });
  }
  function close() {
    if (state !== 'open') return;
    state = 'closing';
    el.classList.remove('is-open');
    setTimeout(function () {
      state = 'closed';
      document.removeEventListener('keydown', onKey, true);
      if (el.parentNode) el.parentNode.removeChild(el);
      inerted.forEach(function (c) { c.removeAttribute('inert'); });
      doc.classList.remove('cayo-popup-open');
      var t = (prevFocus && prevFocus !== document.body && document.contains(prevFocus)) ? prevFocus : document.getElementById('MainContent');
      if (t && t.focus) t.focus({ preventScroll: true });
    }, OUT_MS);
  }
  Array.prototype.forEach.call(el.querySelectorAll('[data-cayo-popup-close]'), function (b) { b.addEventListener('click', close); });
  // Any click outside the card (backdrop or the padding around it) closes too.
  el.addEventListener('click', function (e) { if (!card.contains(e.target)) close(); });

  function schedule() { setTimeout(open, DELAY); }
  var intro = document.getElementById('cayo-intro');
  if (window.__cayoIntroClosed || !intro || intro.hidden) schedule();
  else document.addEventListener('cayo:intro-closed', schedule, { once: true });
  window.CayoPopup = { open: open, close: close, state: function () { return state; } };
})();
